module.exports = __webpack_public_path__ + "static/64eab46d2a38bc024f2759aeb35bd8b1.svg";